import dayjs from 'dayjs'

export type {
  BackofficePisDepositEventResponseV1Dto as PisDepositEvent,
  BackofficePisDepositResponseV1Dto as PisDeposit,
} from '../../api/swagger/definitions/backoffice'

export const PENDING_REASON_LABELS: Record<string, string> = {
  ONLINE_BANK_APPROVAL_REQUIRED: 'Awaiting approval in the payer’s online bank',
  ADDITIONAL_SIGNATORY_APPROVAL_REQUIRED: 'Awaiting an additional signatory',
}

export const FAILURE_REASON_LABELS: Record<string, string> = {
  OPEN_BANKING_NOT_ENABLED: 'Open banking not enabled at the bank',
  PAYMENT_RIGHTS_MISSING: 'Payer lacks payment rights on the account',
}

export const reasonLabel = (reason: string | undefined, labels: Record<string, string>): string | undefined =>
  reason ? (labels[reason] ?? reason) : undefined

// Mirrors the customer-facing map in onboarding src/domain/deposit/Bank.ts
const BANK_NAMES: Record<string, string> = {
  ESSESESS: 'SEB',
  HANDSESS: 'Handelsbanken',
  NDEASESS: 'Nordea',
  SWEDSESS: 'Swedbank',
  DABASESX: 'Danske Bank',
  DNBASESX: 'DNB',
  ELLFSESS: 'Länsförsäkringar',
  SPSDSE23: 'Sparbanken Syd',
  LUNADK2B: 'Lunar',
  REVOLT21: 'Revolut',
  RESUSE2H: 'Resurs Bank',
  AABASESS: 'Ålandsbanken',
  DABADKKK: 'Danske Bank',
  NDEADKKK: 'Nordea',
  ESSEDK22: 'SEB',
  ESSEDKKK: 'SEB',
  DNBANOKK: 'DNB',
  NDEANOKK: 'Nordea',
  DABANO22: 'Danske Bank',
  NDEAFIHH: 'Nordea',
  OKOYFIHH: 'OP',
  ESSEFIHX: 'SEB',
  DABAFIHH: 'Danske Bank',
  HELSFIHH: 'Aktia',
  HOLVFIHH: 'Holvi',
  OMSAFI21: 'Oma Säästöpankki',
  ITELFIHH: 'Säästöpankki',
  POPFFI22: 'POP Pankki',
}

export const bankName = (bic?: string): string | undefined => (bic ? (BANK_NAMES[bic] ?? bic) : undefined)

// The backoffice API serializes Instant as epoch seconds (a JSON number), which dayjs would
// misread as milliseconds — hence the 1970 dates. ISO strings pass through untouched.
export const formatInstant = (value: string | number | undefined, format = 'YYYY-MM-DD HH:mm'): string | undefined => {
  if (value === undefined || value === null) return undefined
  const parsed = typeof value === 'number' ? dayjs(value < 1e12 ? value * 1000 : value) : dayjs(value)
  return parsed.isValid() ? parsed.format(format) : String(value)
}
